import styled, { css } from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'
import {
    Accordion as MuiAccordion,
    AccordionDetails as MuiAccordionDetails,
    AccordionSummary as MuiAccordionSummary,
} from '@material-ui/core'

export const Accordion = styled(MuiAccordion)`
    border-top: 1.5px solid ${({ theme }) => theme.colors.primaryGray2};

    &.MuiAccordion-root {
        box-shadow: none;
    }
`

export const AccordionDetails = styled(MuiAccordionDetails)`
    padding: 0 0 18px;
    display: flex;
    flex-direction: column;
    gap: 18px;
`

export const AccordionSummary = styled(MuiAccordionSummary)`
    width: 100%;
    padding: 0 12px;

    &.MuiAccordionSummary-content {
        margin: 20px 0;
    }
`

export const TemplateTitle = styled.h4`
    flex: 1;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p02Semibold')};
`

export const TemplateContent = styled.div<{ isTitle?: boolean }>`
    padding: 12px;
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.primaryGray0};
    color: ${({ theme }) => theme.colors.secondary500};
    white-space: pre-wrap;
    word-wrap: break-word;

    ${getFontStyle('p02Regular')};

    ${({ isTitle }) =>
        isTitle &&
        css`
            display: flex;
            justify-content: space-between;
            align-items: center;
        `}

    a {
        color: ${({ theme }) => theme.colors.primary50};
    }

    span {
        display: block;

        ${getFontStyle('p02Semibold')};
    }

    .dds-button {
        float: right;
    }
`
